import toast from 'react-hot-toast';

// Toast configuration
const toastConfig = {
  duration: 4000,
  position: 'top-right' as const,
  style: {
    background: '#fff',
    color: '#363636',
    padding: '16px',
    borderRadius: '8px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
  },
};

// Success toast
export const showSuccess = (message: string, options?: any) => {
  return toast.success(message, {
    ...toastConfig,
    ...options,
    icon: '✅',
  });
};

// Error toast
export const showError = (message: string, options?: any) => {
  return toast.error(message, {
    ...toastConfig,
    duration: 5000,
    ...options,
    icon: '❌',
  });
};

// Info toast
export const showInfo = (message: string, options?: any) => {
  return toast(message, {
    ...toastConfig,
    ...options,
    icon: 'ℹ️',
  });
};

// Warning toast
export const showWarning = (message: string, options?: any) => {
  return toast(message, {
    ...toastConfig,
    ...options,
    icon: '⚠️',
    style: {
      ...toastConfig.style,
      background: '#fff3cd',
      color: '#856404',
    },
  });
};

// Loading toast
export const showLoading = (message: string, options?: any) => {
  return toast.loading(message, {
    ...toastConfig,
    ...options,
  });
};

// Promise toast - handles async operations
export const showPromise = <T,>(
  promise: Promise<T>,
  messages: {
    loading: string;
    success: string | ((data: T) => string);
    error: string | ((error: any) => string);
  },
  options?: any
) => {
  return toast.promise(
    promise,
    {
      loading: messages.loading,
      success: messages.success,
      error: messages.error,
    },
    {
      ...toastConfig,
      ...options,
    }
  );
};

// Dismiss a specific toast
export const dismissToast = (toastId: string) => {
  toast.dismiss(toastId);
};

// Dismiss all toasts
export const dismissAllToasts = () => {
  toast.dismiss();
};

// Custom toast with full control
export const showCustom = (message: string, options?: any) => {
  return toast(message, {
    ...toastConfig,
    ...options,
  });
};

// Export the toast instance for advanced usage
export { toast };
